// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"59":"1f69165d","72":"627225bc","159":"b7ba780a","210":"7b3ff0bf","255":"978ff33d","286":"bd36714e","293":"d3141035","437":"15a4008e","481":"f4b8de40","512":"cff3f418","525":"88c2e181","562":"bfe5c45f","628":"12a44af6","810":"42203f51","824":"0a3d6c2c","932":"17ad00eb"}[chunkId] + ".chunk.js";
};